export const customFilter = (
  rows: any[],
  columnIds: string[],
  filterValue: string
) => {
  return rows.filter((row) => {
    const cellValue = row.original[columnIds[0]];

    const aux = cellValue?.key
      ?.toLowerCase()
      ?.includes(filterValue?.toLowerCase());

    return aux;
  });
};
